import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  Divider,
  Chip,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Stack,
  Checkbox,
  ListItemText,
  InputAdornment,
  Autocomplete,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Header from '../components/Admin/header/Header';
import Sidebar from '../components/Admin/Sidebar/Sidebar';
import { ArrowLeft } from 'lucide-react';
import AddIcon from '@mui/icons-material/Add';
import { axiosCall } from '../utils/axiosCall';
import constants from '../config/constants';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AddPackage = () => {
  const [conType, setConType] = useState('OPD');
  const [isEditMode, setIsEditMode] = useState(false);
  const { appointmentId, userId } = useParams();
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [appointmentInfo, setAppointmentInfo] = React.useState({
    UHID: '',
    patientId: '',
    type: 'Appointment',
    subType: 'Appointment',
    doctorName: '',
    doctorDepartment: '',
    doctorTime: '',
    doctorDate: '',
    doctorNotes: '',
  });

  const [patientInfo, setPatientInfo] = React.useState({
    UHID: '#46740303',
    firstName: 'John',
    lastName: 'Wick',
    contactNo: '+1-303-420-4261',
    gender: 'Male',
    address: '6 Doctor House',
    city: 'Mumbai',
    state: 'Maharashtra',
    pinCode: '400026',
    patientImage: '',
  });

  const handleInputChange = () => {};

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: 'flex' }}>
        <Box sx={{}}>
          <Sidebar />
        </Box>
        <Box sx={{ width: '100%' }}>
          {/* Form */}

          <Box
            sx={{
              padding: 2,
              borderRadius: 2,
              marginRight: '90px',
            }}
          >
            <Button
      component={Link}
      to="/patient/packages/details" // replace with the path you want to navigate to
      startIcon={<ArrowLeft />}
      sx={{
        color: '#5D6A82', 
        textTransform: 'none', 
        fontSize: '16px',
        fontWeight: 'bold',
        padding: 0,
      }}
    >
      Back
    </Button>
            {/* Consultation Form */}
            <p
              style={{ fontWeight: 500, fontSize: '20px', color: '#5D6A82', marginTop:'1rem' }}
            >
              Enter Patient Details
            </p>
            

            {/* Patient Information */}
            <Box
              sx={{
                backgroundColor: '#fff',
                borderRadius: 2,
                marginBottom: 2,
                marginTop: 2,
                display: 'flex',
                gap: 2,
              }}
            >
              <Box
                sx={{
                  width: '400px',
                  height: 'auto',
                  border: '1px solid black',
                  borderRadius: 2,
                  marginRight: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                }}
              >
                {/* TODO: Image */}
                <img
                  src={patientInfo.patientImage}
                  alt="Patient"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
              <Box>
                <Typography variant="subtitle1" marginBottom={2} color="grey">
                  Patient Information
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    border: '1px solid #CCD4DA',
                    borderRadius: 2,
                    padding: 2,
                  }}
                >
                  <TextField
                    label="UHID"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                    value={patientInfo.UHID}
                    onChange={handleInputChange}
                    name="UHID"
                  />
                  <TextField
                    label="Name"
                    value={`${patientInfo.firstName} ${patientInfo.lastName}`}
                    onChange={handleInputChange}
                    name="name"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                  <TextField
                    label="Number"
                    value={patientInfo.contactNo}
                    onChange={handleInputChange}
                    name="contactNo"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                  <TextField
                    label="Gender"
                    value={patientInfo.gender}
                    onChange={handleInputChange}
                    name="gender"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                  <TextField
                    label="Address"
                    value={patientInfo.address}
                    onChange={handleInputChange}
                    name="address"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                  <TextField
                    label="City"
                    value={patientInfo.city}
                    onChange={handleInputChange}
                    name="city"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                  <TextField
                    label="State"
                    value={patientInfo.state}
                    onChange={handleInputChange}
                    name="state"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                  <TextField
                    label="Pincode"
                    value={patientInfo.pinCode}
                    onChange={handleInputChange}
                    name="pinCode"
                    InputProps={{ readOnly: true }}
                    sx={{ flex: '1 1 30%' }}
                  />
                </Box>
              </Box>
            </Box>

            {/* COntinue Button */}
            <Box sx={{ textAlign: 'center', marginTop: 3 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  padding: '10px 40px',
                  width: '20%',
                  textTransform: 'none',
                }}
              >
                Continue to Pay
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default AddPackage;
